import { VERMITTLER_UMSATZ_ERFASST_AB_JAHR } from '@rechnungen/shared';

/**
 * BL-375: Hinweis auf die BL-371-Erfassungslücke (Umsatz über die
 * Vermittler Hays/Etengo wird strukturell erst ab
 * `VERMITTLER_UMSATZ_ERFASST_AB_JAHR` erfasst — der Altbestand wird nicht
 * importiert, siehe die Konstante in `@rechnungen/shared`).
 *
 * Rendert nichts, sobald ALLE übergebenen Jahre auf/nach der Grenze liegen —
 * die Aufrufstelle übergibt jedes Jahr, das in der jeweiligen Ansicht
 * tatsächlich sichtbar ist (z.B. `[jahr]` bei einer reinen Einzeljahr-Ansicht,
 * `[jahr, jahr - 1]` wenn zusätzlich ein Vorjahresvergleich gezeigt wird).
 */
export function VermittlerUmsatzHinweis({ jahre }: { jahre: number[] }) {
  const betroffen = jahre.some((j) => j < VERMITTLER_UMSATZ_ERFASST_AB_JAHR);
  if (!betroffen) return null;
  return (
    <span className="text-[11px] text-ink-muted" title="BL-371">
      Zahlen vor {VERMITTLER_UMSATZ_ERFASST_AB_JAHR} enthalten den über Vermittler (Hays/Etengo)
      abgerechneten Umsatz nicht.
    </span>
  );
}

/** Textform desselben Hinweises für Stellen ohne JSX (z.B. KpiCard-`subvalue`). */
export function vermittlerUmsatzHinweisText(jahre: number[]): string | undefined {
  const betroffen = jahre.some((j) => j < VERMITTLER_UMSATZ_ERFASST_AB_JAHR);
  if (!betroffen) return undefined;
  return `Zahlen vor ${VERMITTLER_UMSATZ_ERFASST_AB_JAHR} enthalten den über Vermittler (Hays/Etengo) abgerechneten Umsatz nicht.`;
}
